import { updateCustomerById } from "../../../../app/api/updateCustomerById";
import { BaseAction } from "../../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../../Orchestrator/Recoils/Events/Recoil";
import { IAdditionalPassenger, IApiResponse, IUserResponse } from "../../../../Orchestrator/Types/Index";
import { invalidateUserCaches } from "../invalidateUserCaches";
import dayjs from "dayjs";

interface AddCompanionParams {
	userId: string;
	companionList: IAdditionalPassenger[];
}

class SaveCompanionAction extends BaseAction<IUserResponse, AddCompanionParams> {
	override async run(): Promise<IUserResponse | null> {
		let userResponse: IUserResponse | null = null;
		try {

			const { userId, companionList } = this.params!;
			if (!userId) {
				console.error("User ID not found.");
				return null;
			}
			if (!companionList) {
				console.error("Companion values not provided.");
				return null;
			}

			const response = await updateCustomerById(userId, {
				additionalPassengers: companionList
			});

			if (response.status === "ok" && response.answer) {
				userResponse = response.answer;
				updateRecoilState("userDataAtom", response.answer);
				invalidateUserCaches();
			} else {
				console.warn("Failed to save companion.");
			}
		} catch (error: any) {
			console.error("Error saving companion:", error);
		} finally {
			return userResponse
		}
	}
}

export const saveCompanionAction = new SaveCompanionAction();
